// Countries and Currencies constants
// Based on comprehensive global currency and country data

export const countriesRecord = Object.freeze({
  Afghanistan: 'AF',
  'Aland Islands': 'AX',
  Albania: 'AL',
  Algeria: 'DZ',
  'American Samoa': 'AS',
  Andorra: 'AD',
  Angola: 'AO',
  Anguilla: 'AI',
  Antarctica: 'AQ',
  'Antigua and Barbuda': 'AG',
  Argentina: 'AR',
  Armenia: 'AM',
  Aruba: 'AW',
  Australia: 'AU',
  Austria: 'AT',
  Azerbaijan: 'AZ',
  Bahamas: 'BS',
  Bahrain: 'BH',
  Bangladesh: 'BD',
  Barbados: 'BB',
  Belarus: 'BY',
  Belgium: 'BE',
  Belize: 'BZ',
  Benin: 'BJ',
  Bermuda: 'BM',
  Bhutan: 'BT',
  Bolivia: 'BO',
  'Bosnia and Herzegovina': 'BA',
  Botswana: 'BW',
  'Bouvet Island': 'BV',
  Brazil: 'BR',
  'British Indian Ocean Territory': 'IO',
  Brunei: 'BN',
  Bulgaria: 'BG',
  'Burkina Faso': 'BF',
  Burundi: 'BI',
  Cambodia: 'KH',
  Cameroon: 'CM',
  Canada: 'CA',
  'Cape Verde': 'CV',
  'Cayman Islands': 'KY',
  'Central African Republic': 'CF',
  Chad: 'TD',
  Chile: 'CL',
  China: 'CN',
  'Christmas Island': 'CX',
  'Cocos (Keeling) Islands': 'CC',
  Colombia: 'CO',
  Comoros: 'KM',
  Congo: 'CG',
  'Congo, Democratic Republic': 'CD',
  'Cook Islands': 'CK',
  'Costa Rica': 'CR',
  "Cote d'Ivoire": 'CI',
  Croatia: 'HR',
  Cuba: 'CU',
  Cyprus: 'CY',
  'Czech Republic': 'CZ',
  Denmark: 'DK',
  Djibouti: 'DJ',
  Dominica: 'DM',
  'Dominican Republic': 'DO',
  Ecuador: 'EC',
  Egypt: 'EG',
  'El Salvador': 'SV',
  'Equatorial Guinea': 'GQ',
  Eritrea: 'ER',
  Estonia: 'EE',
  Ethiopia: 'ET',
  'Falkland Islands': 'FK',
  'Faroe Islands': 'FO',
  Fiji: 'FJ',
  Finland: 'FI',
  France: 'FR',
  'French Guiana': 'GF',
  'French Polynesia': 'PF',
  'French Southern Territories': 'TF',
  Gabon: 'GA',
  Gambia: 'GM',
  Georgia: 'GE',
  Germany: 'DE',
  Ghana: 'GH',
  Gibraltar: 'GI',
  Greece: 'GR',
  Greenland: 'GL',
  Grenada: 'GD',
  Guadeloupe: 'GP',
  Guam: 'GU',
  Guatemala: 'GT',
  Guernsey: 'GG',
  Guinea: 'GN',
  'Guinea-Bissau': 'GW',
  Guyana: 'GY',
  Haiti: 'HT',
  'Heard Island': 'HM',
  'Holy See (Vatican City)': 'VA',
  Honduras: 'HN',
  'Hong Kong': 'HK',
  Hungary: 'HU',
  Iceland: 'IS',
  India: 'IN',
  Indonesia: 'ID',
  Iran: 'IR',
  Iraq: 'IQ',
  Ireland: 'IE',
  'Isle of Man': 'IM',
  Israel: 'IL',
  Italy: 'IT',
  Jamaica: 'JM',
  Japan: 'JP',
  Jersey: 'JE',
  Jordan: 'JO',
  Kazakhstan: 'KZ',
  Kenya: 'KE',
  Kiribati: 'KI',
  'Korea, North': 'KP',
  'Korea, South': 'KR',
  Kuwait: 'KW',
  Kyrgyzstan: 'KG',
  Laos: 'LA',
  Latvia: 'LV',
  Lebanon: 'LB',
  Lesotho: 'LS',
  Liberia: 'LR',
  Libya: 'LY',
  Liechtenstein: 'LI',
  Lithuania: 'LT',
  Luxembourg: 'LU',
  Macao: 'MO',
  Macedonia: 'MK',
  Madagascar: 'MG',
  Malawi: 'MW',
  Malaysia: 'MY',
  Maldives: 'MV',
  Mali: 'ML',
  Malta: 'MT',
  'Marshall Islands': 'MH',
  Martinique: 'MQ',
  Mauritania: 'MR',
  Mauritius: 'MU',
  Mayotte: 'YT',
  Mexico: 'MX',
  Micronesia: 'FM',
  Moldova: 'MD',
  Monaco: 'MC',
  Mongolia: 'MN',
  Montenegro: 'ME',
  Montserrat: 'MS',
  Morocco: 'MA',
  Mozambique: 'MZ',
  Myanmar: 'MM',
  Namibia: 'NA',
  Nauru: 'NR',
  Nepal: 'NP',
  Netherlands: 'NL',
  'Netherlands Antilles': 'AN',
  'New Caledonia': 'NC',
  'New Zealand': 'NZ',
  Nicaragua: 'NI',
  Niger: 'NE',
  Nigeria: 'NG',
  Niue: 'NU',
  'Norfolk Island': 'NF',
  'Northern Mariana Islands': 'MP',
  Norway: 'NO',
  Oman: 'OM',
  Pakistan: 'PK',
  Palau: 'PW',
  Palestine: 'PS',
  Panama: 'PA',
  'Papua New Guinea': 'PG',
  Paraguay: 'PY',
  Peru: 'PE',
  Philippines: 'PH',
  Pitcairn: 'PN',
  Poland: 'PL',
  Portugal: 'PT',
  'Puerto Rico': 'PR',
  Qatar: 'QA',
  Reunion: 'RE',
  Romania: 'RO',
  'Russian Federation': 'RU',
  Rwanda: 'RW',
  'Saint Barthelemy': 'BL',
  'Saint Helena': 'SH',
  'Saint Kitts and Nevis': 'KN',
  'Saint Lucia': 'LC',
  'Saint Martin': 'MF',
  'Saint Pierre and Miquelon': 'PM',
  'Saint Vincent and the Grenadines': 'VC',
  Samoa: 'WS',
  'San Marino': 'SM',
  'Sao Tome and Principe': 'ST',
  'Saudi Arabia': 'SA',
  Senegal: 'SN',
  Serbia: 'RS',
  Seychelles: 'SC',
  'Sierra Leone': 'SL',
  Singapore: 'SG',
  Slovakia: 'SK',
  Slovenia: 'SI',
  'Solomon Islands': 'SB',
  Somalia: 'SO',
  'South Africa': 'ZA',
  'South Georgia': 'GS',
  Spain: 'ES',
  'Sri Lanka': 'LK',
  Sudan: 'SD',
  Suriname: 'SR',
  'Svalbard and Jan Mayen': 'SJ',
  Swaziland: 'SZ',
  Sweden: 'SE',
  Switzerland: 'CH',
  'Syrian Arab Republic': 'SY',
  Taiwan: 'TW',
  Tajikistan: 'TJ',
  Tanzania: 'TZ',
  Thailand: 'TH',
  'Timor-Leste': 'TL',
  Togo: 'TG',
  Tokelau: 'TK',
  Tonga: 'TO',
  'Trinidad and Tobago': 'TT',
  Tunisia: 'TN',
  Turkey: 'TR',
  Turkmenistan: 'TM',
  'Turks and Caicos Islands': 'TC',
  Tuvalu: 'TV',
  Uganda: 'UG',
  Ukraine: 'UA',
  'United Arab Emirates': 'AE',
  'United Kingdom': 'GB',
  'United States': 'US',
  'United States Minor Outlying Islands': 'UM',
  Uruguay: 'UY',
  Uzbekistan: 'UZ',
  Vanuatu: 'VU',
  Venezuela: 'VE',
  Vietnam: 'VN',
  'Virgin Islands, British': 'VG',
  'Virgin Islands, U.S.': 'VI',
  'Wallis and Futuna': 'WF',
  'Western Sahara': 'EH',
  Yemen: 'YE',
  Zambia: 'ZM',
  Zimbabwe: 'ZW',
});

export const currenciesRecord = Object.freeze({
  'Afghan Afghani': 'AFN',
  'Albanian Lek': 'ALL',
  'Algerian Dinar': 'DZD',
  'Angolan Kwanza': 'AOA',
  'Argentine Peso': 'ARS',
  'Armenian Dram': 'AMD',
  'Aruban Florin': 'AWG',
  'Australian Dollar': 'AUD',
  'Azerbaijani Manat': 'AZN',
  'Bahamian Dollar': 'BSD',
  'Bahraini Dinar': 'BHD',
  'Bangladeshi Taka': 'BDT',
  'Barbadian Dollar': 'BBD',
  'Belarusian Ruble': 'BYN',
  'Belize Dollar': 'BZD',
  'Bermudian Dollar': 'BMD',
  'Bhutanese Ngultrum': 'BTN',
  Bitcoin: 'BTC',
  'Bolivian Boliviano': 'BOB',
  'Bosnia-Herzegovina Convertible Mark': 'BAM',
  'Botswanan Pula': 'BWP',
  'Brazilian Real': 'BRL',
  'British Pound Sterling': 'GBP',
  'Brunei Dollar': 'BND',
  'Bulgarian Lev': 'BGN',
  'Burundian Franc': 'BIF',
  'Cambodian Riel': 'KHR',
  'Canadian Dollar': 'CAD',
  'Cape Verdean Escudo': 'CVE',
  'Cayman Islands Dollar': 'KYD',
  'CFA Franc BCEAO': 'XOF',
  'CFA Franc BEAC': 'XAF',
  'CFP Franc': 'XPF',
  'Chilean Peso': 'CLP',
  'Chinese Yuan': 'CNY',
  'Colombian Peso': 'COP',
  'Comorian Franc': 'KMF',
  'Congolese Franc': 'CDF',
  'Costa Rican Colon': 'CRC',
  'Croatian Kuna': 'HRK',
  'Cuban Peso': 'CUP',
  'Czech Republic Koruna': 'CZK',
  'Danish Krone': 'DKK',
  'Djiboutian Franc': 'DJF',
  'Dominican Peso': 'DOP',
  'East Caribbean Dollar': 'XCD',
  'Egyptian Pound': 'EGP',
  'Eritrean Nakfa': 'ERN',
  'Estonian Kroon': 'EEK',
  'Ethiopian Birr': 'ETB',
  Euro: 'EUR',
  'Falkland Islands Pound': 'FKP',
  'Fijian Dollar': 'FJD',
  'Gambian Dalasi': 'GMD',
  'Georgian Lari': 'GEL',
  'German Mark': 'DEM',
  'Ghanaian Cedi': 'GHS',
  'Gibraltar Pound': 'GIP',
  'Greek Drachma': 'GRD',
  'Guatemalan Quetzal': 'GTQ',
  'Guinean Franc': 'GNF',
  'Guyanaese Dollar': 'GYD',
  'Haitian Gourde': 'HTG',
  'Honduran Lempira': 'HNL',
  'Hong Kong Dollar': 'HKD',
  'Hungarian Forint': 'HUF',
  'Icelandic Krona': 'ISK',
  'Indian Rupee': 'INR',
  'Indonesian Rupiah': 'IDR',
  'Iranian Rial': 'IRR',
  'Iraqi Dinar': 'IQD',
  'Israeli New Sheqel': 'ILS',
  'Italian Lira': 'ITL',
  'Jamaican Dollar': 'JMD',
  'Japanese Yen': 'JPY',
  'Jordanian Dinar': 'JOD',
  'Kazakhstani Tenge': 'KZT',
  'Kenyan Shilling': 'KES',
  'Kuwaiti Dinar': 'KWD',
  'Kyrgystani Som': 'KGS',
  'Laotian Kip': 'LAK',
  'Latvian Lats': 'LVL',
  'Lebanese Pound': 'LBP',
  'Lesotho Loti': 'LSL',
  'Liberian Dollar': 'LRD',
  'Libyan Dinar': 'LYD',
  'Lithuanian Litas': 'LTL',
  'Macanese Pataca': 'MOP',
  'Macedonian Denar': 'MKD',
  'Malagasy Ariary': 'MGA',
  'Malawian Kwacha': 'MWK',
  'Malaysian Ringgit': 'MYR',
  'Maldivian Rufiyaa': 'MVR',
  'Mauritanian Ouguiya': 'MRU',
  'Mauritian Rupee': 'MUR',
  'Mexican Peso': 'MXN',
  'Moldovan Leu': 'MDL',
  'Mongolian Tugrik': 'MNT',
  'Moroccan Dirham': 'MAD',
  'Mozambican Metical': 'MZN',
  'Myanmar Kyat': 'MMK',
  'Namibian Dollar': 'NAD',
  'Nepalese Rupee': 'NPR',
  'Netherlands Antillean Guilder': 'ANG',
  'New Zealand Dollar': 'NZD',
  'Nicaraguan Cordoba': 'NIO',
  'Nigerian Naira': 'NGN',
  'North Korean Won': 'KPW',
  'Norwegian Krone': 'NOK',
  'Omani Rial': 'OMR',
  'Pakistani Rupee': 'PKR',
  'Panamanian Balboa': 'PAB',
  'Papua New Guinean Kina': 'PGK',
  'Paraguayan Guarani': 'PYG',
  'Peruvian Nuevo Sol': 'PEN',
  'Philippine Peso': 'PHP',
  'Polish Zloty': 'PLN',
  'Qatari Rial': 'QAR',
  'Romanian Leu': 'RON',
  'Russian Ruble': 'RUB',
  'Rwandan Franc': 'RWF',
  'Salvadoran Colon': 'SVC',
  'Saudi Riyal': 'SAR',
  'Serbian Dinar': 'RSD',
  'Seychellois Rupee': 'SCR',
  'Sierra Leonean Leone': 'SLL',
  'Singapore Dollar': 'SGD',
  'Slovak Koruna': 'SKK',
  'Solomon Islands Dollar': 'SBD',
  'Somali Shilling': 'SOS',
  'South African Rand': 'ZAR',
  'South Korean Won': 'KRW',
  'Special Drawing Rights': 'XDR',
  'Sri Lankan Rupee': 'LKR',
  'St. Helena Pound': 'SHP',
  'Sudanese Pound': 'SDG',
  'Surinamese Dollar': 'SRD',
  'Swazi Lilangeni': 'SZL',
  'Swedish Krona': 'SEK',
  'Swiss Franc': 'CHF',
  'Syrian Pound': 'SYP',
  'Taiwan New Dollar': 'TWD',
  'Tajikistani Somoni': 'TJS',
  'Tanzanian Shilling': 'TZS',
  'Thai Baht': 'THB',
  'Trinidad & Tobago Dollar': 'TTD',
  'Tunisian Dinar': 'TND',
  'Turkish Lira': 'TRY',
  'Turkmenistani Manat': 'TMT',
  'Ugandan Shilling': 'UGX',
  'Ukrainian Hryvnia': 'UAH',
  'United Arab Emirates Dirham': 'AED',
  'Uruguayan Peso': 'UYU',
  'US Dollar': 'USD',
  'Uzbekistan Som': 'UZS',
  'Venezuelan Bolivar': 'VES',
  'Vietnamese Dong': 'VND',
  'Yemeni Rial': 'YER',
  'Zambian Kwacha': 'ZMW',
  'Zimbabwean Dollar': 'ZWL',
  'Gold Ounce': 'XAU',
  'Silver Ounce': 'XAG',
  'Platinum Ounce': 'XPT',
  'Palladium Ounce': 'XPD',
});

// This is for IRS use of currency exchange rate from US treasury
// https://fiscaldata.treasury.gov/datasets/treasury-reporting-rates-exchange/treasury-reporting-rates-of-exchange
export const usTreasuryForeignCurrenciesRecord = [
  'Afghanistan-Afghani',
  'Albania-Lek',
  'Algeria-Dinar',
  'Angola-Kwanza',
  'Antigua & Barbuda-East Caribbean Dollar',
  'Argentina-Peso',
  'Armenia-Dram',
  'Australia-Dollar',
  'Austria-Euro',
  'Azerbaijan-Manat',
  'Bahamas-Dollar',
  'Bahrain-Dinar',
  'Bangladesh-Taka',
  'Barbados-Dollar',
  'Belarus-New Ruble',
  'Belgium-Euro',
  'Belize-Dollar',
  'Benin-Cfa Franc',
  'Bermuda-Dollar',
  'Bolivia-Boliviano',
  'Bosnia-Marka',
  'Botswana-Pula',
  'Brazil-Real',
  'Brunei-Dollar',
  'Bulgaria-Lev New',
  'Burkina Faso-Cfa Franc',
  'Burundi-Franc',
  'Cambodia-Riel',
  'Cameroon-Cfa Franc',
  'Canada-Dollar',
  'Cape Verde-Escudo',
  'Cayman Islands-Dollar',
  'Central African Republic-Cfa Franc',
  'Chad-Cfa Franc',
  'Chile-Peso',
  'China-Renminbi',
  'Colombia-Peso',
  'Comoros-Franc',
  'Congo-Cfa Franc',
  'Costa Rica-Colon',
  "Cote D'Ivoire-Cfa Franc",
  'Croatia-Euro',
  'Croatia-Kuna',
  'Cross Border-Euro',
  'Cuba-Chavito',
  'Cuba-Peso',
  'Cyprus-Euro',
  'Czech Republic-Koruna',
  'Democratic Republic Of Congo-Congolese Franc',
  'Denmark-Krone',
  'Djibouti-Franc',
  'Dominican Republic-Peso',
  'Ecuador-Dolares',
  'Egypt-Pound',
  'El Salvador-Dollar',
  'Equatorial Guinea-Cfa Franc',
  'Eritrea-Nakfa',
  'Eritrea-Nakfa Salary Payment',
  'Estonia-Euro',
  'Eswatini-Lilangeni',
  'Ethiopia-Birr',
  'Euro Zone-Euro',
  'Fiji-Dollar',
  'Finland-Euro',
  'France-Euro',
  'Gabon-Cfa Franc',
  'Gambia-Dalasi',
  'Georgia-Lari',
  'Germany-Euro',
  'Ghana-Cedi',
  'Greece-Euro',
  'Grenada-East Caribbean Dollar',
  'Guatemala-Quetzal',
  'Guinea Bissau-Cfa Franc',
  'Guinea-Franc',
  'Guyana-Dollar',
  'Haiti-Gourde',
  'Honduras-Lempira',
  'Hong Kong-Dollar',
  'Hungary-Forint',
  'Iceland-Krona',
  'India-Rupee',
  'Indonesia-Rupiah',
  'Iran-Rial',
  'Iraq-Dinar',
  'Ireland-Euro',
  'Israel-Shekel',
  'Italy-Euro',
  'Jamaica-Dollar',
  'Japan-Yen',
  'Jordan-Dinar',
  'Kazakhstan-Tenge',
  'Kenya-Shilling',
  'Korea-Won',
  'Kosovo-Euro',
  'Kuwait-Dinar',
  'Kyrgyzstan-Som',
  'Laos-Kip',
  'Latvia-Euro',
  'Lebanon-Pound',
  'Lesotho-Maloti',
  'Liberia-Dollar',
  'Libya-Dinar',
  'Lithuania-Euro',
  'Luxembourg-Euro',
  'Madagascar-Ariary',
  'Malawi-Kwacha',
  'Malaysia-Ringgit',
  'Maldives-Rufiyaa',
  'Mali-Cfa Franc',
  'Malta-Euro',
  'Marshall Islands-U.S. Dollar',
  'Mauritania-Ouguiya',
  'Mauritius-Rupee',
  'Mexico-Peso',
  'Micronesia-U.S. Dollar',
  'Moldova-Leu',
  'Mongolia-Tugrik',
  'Montenegro-Euro',
  'Morocco-Dirham',
  'Mozambique-Metical',
  'Myanmar-Kyat',
  'Namibia-Dollar',
  'Nepal-Rupee',
  'Netherlands Antilles-Guilder',
  'Netherlands-Euro',
  'New Zealand-Dollar',
  'Nicaragua-Cordoba',
  'Niger-Cfa Franc',
  'Nigeria-Naira',
  'Norway-Krone',
  'Oman-Rial',
  'Pakistan-Rupee',
  'Palau-Dollar',
  'Panama-Balboa',
  'Panama-Dolares',
  'Papua New Guinea-Kina',
  'Paraguay-Guarani',
  'Peru-Sol',
  'Philippines-Peso',
  'Poland-Zloty',
  'Portugal-Euro',
  'Qatar-Riyal',
  'Republic Of North Macedonia-Denar',
  'Romania-New Leu',
  'Russia-Ruble',
  'Rwanda-Franc',
  'Sao Tome & Principe-New Dobras',
  'Saudi Arabia-Riyal',
  'Senegal-Cfa Franc',
  'Serbia-Dinar',
  'Seychelles-Rupee',
  'Sierra Leone-Leone',
  'Sierra Leone-Old Leone',
  'Singapore-Dollar',
  'Slovakia-Euro',
  'Slovenia-Euro',
  'Solomon Islands-Dollar',
  'Somali-Shilling',
  'South Africa-Rand',
  'South Sudan-Sudanese Pound',
  'Spain-Euro',
  'Sri Lanka-Rupee',
  'St. Lucia-East Caribbean Dollar',
  'Sudan-Pound',
  'Suriname-Dollar',
  'Sweden-Krona',
  'Switzerland-Franc',
  'Syria-Pound',
  'Taiwan-Dollar',
  'Tajikistan-Somoni',
  'Tanzania-Shilling',
  'Thailand-Baht',
  'Timor-Leste-Dili',
  'Togo-Cfa Franc',
  "Tonga-Pa'Anga",
  'Trinidad & Tobago-Dollar',
  'Tunisia-Dinar',
  'Turkey-New Lira',
  'Turkmenistan-New Manat',
  'Uganda-Shilling',
  'Ukraine-Hryvnia',
  'United Arab Emirates-Dirham',
  'United Kingdom-Pound',
  'United States-Dollar',
  'Uruguay-Peso',
  'Uzbekistan-Som',
  'Vanuatu-Vatu',
  'Venezuela-Bolivar Soberano',
  'Venezuela-Fuerte',
  'Vietnam-Dong',
  'Western Samoa-Tala',
  'Yemen-Rial',
  'Zambia-New Kwacha',
  'Zimbabwe-Gold',
  'Zimbabwe-Rtgs',
];

export const countries = Object.keys(countriesRecord);
export const countryKeys = Object.values(countriesRecord);

export const currencies = Object.keys(currenciesRecord);
export const currencyKeys = Object.values(currenciesRecord);

// Helper function to get currency with code format
export const getCurrencyWithCode = currencyName => {
  const code = currenciesRecord[currencyName];
  return code ? `${currencyName} (${code})` : currencyName;
};

// Helper function to get all currencies with codes
export const getCurrenciesWithCodes = () => {
  return Object.keys(currenciesRecord).map(currency =>
    getCurrencyWithCode(currency),
  );
};
